module.exports = __webpack_public_path__ + "img/icon-poly-2ff6d31b.svg";